import React from 'react';
import MainRoute from "./pages/MainRoute";
import { BrowserRouter, useLocation } from 'react-router-dom';
import Header from './pages/Header';
import Footer from './pages/Footer';
import ErrorBoundary from './component/ErrorBoundary';
import AdminApp from './pages/admin';
import './assets/css/Common.css'
import './assets/css/Style.css'

function AppLayout() {
    const location = useLocation();
    const isErrorMonitor = location?.pathname?.startsWith('/error-monitor');
    const isAdmin = location?.pathname?.startsWith('/admin');

    // Admin console is fully standalone: its own login/token, no site Header/Footer,
    // and not gated by MainRoute's WP-redirect auth.
    if (isAdmin) {
        return (
            <ErrorBoundary>
                <AdminApp />
            </ErrorBoundary>
        );
    }

    return (
        <ErrorBoundary>
            {!isErrorMonitor && <Header />}

            {isErrorMonitor ? (
                <ErrorBoundary>
                    <MainRoute />
                </ErrorBoundary>
            ) : (
                <main className='hw-app--main'>
                    <ErrorBoundary>
                        <MainRoute />
                    </ErrorBoundary>
                </main>
            )}

            {!isErrorMonitor && <Footer />}
            {!isErrorMonitor && <div className='hw-menu--overlay' />}
        </ErrorBoundary>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppLayout />
        </BrowserRouter>
    );
}

export default App;